(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.onlineform = skyward.onlineform || {};
        const inited = skyward.events.getCallbackStore();
        skyward.onlineform.inited = skyward.events.getCallbackStoreFacadeCollection({ inited }).inited;

        var init = function (selector)
        {
            return initInternal.call(this, selector).then(() => inited.dispatchCallbacks.call(this, selector));
        };

        var initInternal = async function (selector)
        {
            const selectorElement = $(selector);
            skyward.electronicSignature.registerElectronicSignatureAgreeCheckboxEvent(selectorElement.find(".electronicSignatureAgreeCheckbox"));

            var hiddenAddressContainer = $("[id$=HiddenAddressID]");
            if (hiddenAddressContainer.length)
            {
                var hiddenAddressIDName = $(selector).find("[id$=HiddenAddressIDName]");
                if (hiddenAddressIDName.length)
                {
                    var hiddenAddressIDContainer = $(selector).find("[id$=" + hiddenAddressIDName.val() + "]");
                    if (hiddenAddressIDContainer.length)
                    {
                        hiddenAddressIDContainer.val(hiddenAddressContainer.val());
                    }
                }
            }

            selectorElement.find('.languageOptionTypeCode').change(languageOptionTypeRadioGroupChange);

            var stepStatusSection = selectorElement.find('.onlineFormReviewHeading.js-scrollTo');
            if (stepStatusSection.length)
            {
                stepStatusSection[0].scrollIntoView();
            }

            // TODO (3902178 - Make Online Forms Mobile Friendly) double check if this is needed
            selectorElement.find(' .printOnlineFormAdminReviewButton').on('click', function () { print($(this), $(".onlineFormAdminReview")); });

            selectorElement.find('.onlineFormContent.js-printOnlineFormHtmlElement').on('click', function () { printHtmlElement($(this)); });

            selectorElement.find('.onlineFormContent.js-printOnlineFormMergeMarkupElement').on('click', function () { printHtmlElement($(this)); });

            selectorElement.find('.onlineForm_DeleteOnlineFormButton').on("click", deleteOnlineForm);

            selectorElement.find('.ElementQuickEntry').not('.onlineFormElementEventsBound').each(function ()
            {
                var elementRepeaterParent = $(this);

                elementRepeaterParent.on('childrecordquickentry-row-added', function (_, newRow)
                {
                    rowAddedUpdateOrder(newRow);
                });

                elementRepeaterParent.on('childrecordquickentry-row-cleared', function (_, clearedRow, isRowBeingRemoved)
                {
                    rowClearedUpdateElementOrder(clearedRow, isRowBeingRemoved, elementRepeaterParent);

                    if (!isRowBeingRemoved)
                    {
                        clearedRow.find('[data-default-state]:input', '[data-default-checkbox-state]:input:checkbox').each(function ()
                        {
                            var defaultState = $(this);
                            skyward.controls.setValue(defaultState, defaultState.data('defaultState'));
                        });
                    }
                });

                elementRepeaterParent.addClass('onlineFormElementEventsBound');
            });

            var iFrames = $(selector + ' .onlineForm.iFrame');

            var embeddedLinkContainer = selectorElement.find(".onlineForm.embeddedLinkContainer");
            if (embeddedLinkContainer.length > 0)
            {
                iFrames.each(function ()
                {
                    setupEmbeddedLink($(this));
                });
            }

            var htmlContainers = $(selector + " .onlineForm.htmlContainer");
            await $.whenAllSettled(htmlContainers.toArray().map(async function (elem)
            {
                var htmlContainer = $(elem);
                var iFrame = htmlContainer.find('.onlineForm.iFrame');

                if (iFrame.hasClass('skipIFrameSrcInit'))
                {
                    return;
                }

                await setupHtmlIFrame(htmlContainer, iFrame);
            }))
            .catch(() => { });

            const nonIgnoredIFrames = iFrames.filter(':not(.js-ignoreIFrameContents)').toArray();
            // Hidden iframes mostly don't perform layout, so setupIFrame can only calculate the correct
            // height for the visible ones.
            await $.whenAllSettled(nonIgnoredIFrames
                .map(function (iframe)
                {
                    return setupIFrame($(iframe));
                }))
                .catch(() => { });

            // mass print takes care of resizing iframes itself
            if (!matchMedia("print"))
            {
                skyward.window.registerLayoutResizeCallback(function ()
                {
                    iFrames.filter(':not(.js-ignoreIFrameContents)').add(htmlContainers.find('.onlineForm.iFrame')).each(function ()
                    {
                        skyward.onlineform.setupIframeHeight($(this), "resize");
                    });
                });
            }

            var mergeMarkupContainers = selectorElement.find('.onlineForm.mergeMarkupContainer');
            mergeMarkupContainers.each(function ()
            {
                setupMergeMarkup($(this));
            });

            selectorElement.find('.raceEthnicityVerification').change(function (e)
            {
                var raceEthnicity = $(this);

                var hiddenValue = raceEthnicity.find('.raceEthnicityVerificationHiddenValue');
                var values = {};
                raceEthnicity.find(':input, .languageOptionTypeCode').not(hiddenValue).each(function ()
                {
                    var input = $(this);
                    var parsedControl = getNameOrId(input).split('_')[0];
                    if (parsedControl.length)
                    {
                        values[parsedControl] = skyward.controls.getValue(input);
                    }
                });
                hiddenValue.val(JSON.stringify(values));
            });

            selectorElement.find('.codeEEL > .onlineFormAdminReviewControlHighlight').each(function ()
            {
                $(this).closest('.codeEEL').addClass('onlineFormAdminReviewControlHighlight');
            });

            selectorElement.find('.stepRow').each(function ()
            {
                var stepRow = $(this);

                if (!stepRow.length)
                {
                    return;
                }

                var currentValues = stepRow.find('.onlineFormCurrentValue .onlineFormAdminReviewElement');
                var updatedValues = stepRow.find('.onlineFormUpdatedValue .onlineFormAdminReviewElement');
                if (currentValues.length && updatedValues.length)
                {
                    updatedValues.each(function (index)
                    {
                        var updatedValue = $(this);
                        var currentValue = currentValues.eq(index);
                        if (currentValue.length)
                        {
                            var updatedValueHeight = updatedValue.height();
                            var currentValueHeight = currentValue.height();
                            if (updatedValueHeight < currentValueHeight)
                            {
                                updatedValue.css('min-height', currentValueHeight);
                            }
                            else if (updatedValueHeight > currentValueHeight)
                            {
                                currentValue.css('min-height', updatedValueHeight);
                            }
                        }
                    });
                }
            });

            $(selector + ' #AttachmentLocationSelectEEL').change(function ()
            {
                const selectedAttachmentLocationValue = $(this).get(0).value;
                var selectedAttachmentLocationDatas = selectedAttachmentLocationValue ? selectedAttachmentLocationValue.split(',') : [];
                var hideStudentGeneralAttachmentLocationDetails = true;
                var $studentGeneralAttachmentLocationDetailsDiv = $("#StudentGeneralAttachmentLocationDetailsDiv");
                if ($studentGeneralAttachmentLocationDetailsDiv.length == 0)
                {
                    $studentGeneralAttachmentLocationDetailsDiv = $("#editAttachmentType_StudentGeneralAttachmentLocationDetailsDiv");
                }

                for (var i = 0; i < selectedAttachmentLocationDatas.length; i++)
                {
                    var selectedAttachmentLocationCode = selectedAttachmentLocationDatas[i].split(':')[1];
                    if (selectedAttachmentLocationCode == "\"STU-GEN\"" || selectedAttachmentLocationCode == "\"STU-GEN\"}")
                    {
                        skyward.controls.show($studentGeneralAttachmentLocationDetailsDiv);
                        hideStudentGeneralAttachmentLocationDetails = false;
                        break;
                    }
                }

                if (hideStudentGeneralAttachmentLocationDetails)
                {
                    skyward.controls.hide($studentGeneralAttachmentLocationDetailsDiv);
                }
            });

            skyward.changeTracking.setUpChangeTracking(selector + " .onlineFormArea");

            selectorElement.find('.js-allowLanguageUpdateCheckbox').on("change", allowLanguageUpdateCheckboxChange);

            selectorElement.find('.js-approvalNeededRadioButton').change(approvalNeededRadioButtonChange);

            selectorElement.find('.js-approvalOptionRadioButtonGroup').on("change", approvalOptionRadioButtonGroupChange);

            selectorElement.find('.js-elementTypeComboBox').change(elementTypeComboBoxChange);

            selectorElement.find('.js-fieldGroupTypeComboBox').change(fieldGroupTypeComboBoxChange);

            setStepFilterModifiedNotification(selectorElement, ".js-stepFilterViewerPromptPanel", ".filterValue");
            setStepFilterModifiedNotification(selectorElement, ".js-stepFilterViewerAdvancedFilterPanel", ".filterViewValue");
        };

        var elementOrderLabelPrefix = 'Element Order: ';

        var parseElementOrderFromLabelText = function (elementOrderLabelText)
        {
            return parseInt(elementOrderLabelText.substring(elementOrderLabelPrefix.length), 10);
        };

        var rowAddedUpdateOrder = function (newRow)
        {
            var newRowElementOrderLabel = newRow.find('.elementOrderLabel');
            var previousElementOrderValue = parseElementOrderFromLabelText(newRow.prev('.childrecordquickentryrow').find('.elementOrderLabel').text());
            if (previousElementOrderValue)
            {
                newRowElementOrderLabel.text(elementOrderLabelPrefix + (previousElementOrderValue + 1));
            }
        };

        var rowClearedUpdateElementOrder = function (clearedRow, isRowBeingRemoved)
        {
            if (isRowBeingRemoved)
            {
                var elementOrder = parseElementOrderFromLabelText(clearedRow.find('.elementOrderLabel').text());
                if (!elementOrder)
                {
                    return;
                }

                clearedRow.nextAll('.childrecordquickentryrow').each(function ()
                {
                    var elementOrderLabel = $(this).find('.elementOrderLabel');
                    if (elementOrderLabel.length)
                    {
                        elementOrderLabel.text(elementOrderLabelPrefix + elementOrder);
                        elementOrder++;
                    }
                });
            }
        };

        skyward.onlineform.processManagerUpdateLinkActionWithPrimaryKey = function (clickedElement)
        {
            var onlineFormStatusID = $(clickedElement).val();

            var button = $(clickedElement.parentElement.parentElement).find(".processTaskElementInstance__actionButton")
            button.off("click");
            button.prop("onclick", null);
            button.on("click", function ()
            {
                if ($(this).hasClass('ui-disabled'))
                {
                    return false;
                }
                skyward.window.loadContent('popout', 'OnlineForm', 'OnlineFormStatus', 'Details', onlineFormStatusID, {}
                    ,null, null, null, false, null, null, null, null, null, null);
            });
        }

        skyward.onlineform.createFieldSelector = function (clickedElement)
        {
            if (!(clickedElement instanceof $))
            {
                clickedElement = $(clickedElement);
            }
            var isWorkflow = clickedElement.parents('.workflow').length > 0;
            var module = $('.onlineFormModule').val();
            var object = $('.onlineFormObject').val();

            if (!module || !object)
            {
                return;
            }

            var saveButton = {
                text: "Select Field",
                "click": function ()
                {
                    selectField(clickedElement, fieldSelectModal, isWorkflow, module, object);
                },
                "icon": "Select"
            };
            var cancelButton = { text: "Cancel", "click": "close", "icon": "Cancel" };
            var options =
                {
                    anchorTo: clickedElement
                };

            var fieldSelectModal = skyward.modalLayer.showDialog("Select Field", function () { return buildSelectFieldPopup(module, object, isWorkflow, clickedElement); }, [saveButton, cancelButton], options);

            fieldSelectModal.content.on('contentLoaded', function ()
            {
                fieldSelectModal.animateModalContents();
                skyward.window.notifyDOMLoad('.insertColumnTreeBrowse');
            });
            fieldSelectModal.content.on('treeBrowseContentLoaded', function ()
            {
                fieldSelectModal.animateModalContents();
            });
            fieldSelectModal.content.on('treeBrowseSave', function ()
            {
                selectField(clickedElement, fieldSelectModal, isWorkflow, module, object);
            });
        };

        var getRelationshipPathMinusInitialRootObject = function (relationshipPath)
        {
            return relationshipPath.substring(relationshipPath.indexOf('.') + 1);
        };

        var selectField = function (fieldSelectButton, fieldSelectModal, isWorkflow, module, object)
        {
            var listData = skyward.treebrowse.getSelectedFieldData(fieldSelectModal.content);

            if (!listData || !listData.fieldName || !listData.fieldType)
            {
                return;
            }

            var isRelationship = listData.fieldType === 'ManyToOne';

            var fieldNameData = isRelationship
                ? getRelationshipPathMinusInitialRootObject(listData.fieldName)
                : listData.absoluteFieldPath;

            if (!fieldNameData)
            {
                return;
            }

            $.ajax(
            {
                url: skyward.global.virtualDir + 'OnlineForm/Step/UpdateFieldOptions' + (isWorkflow ? 'Workflow' : 'Details'),
                type: "POST",
                data:
                {
                    moduleName: module,
                    objectName: object,
                    fieldName: fieldNameData,
                    isRelationship: isRelationship
                },
                success: function (data)
                {
                    var fieldSelectContainer = fieldSelectButton.parents('.onlineformelement:eq(0)');
                    var radioButtonGroupValue = fieldSelectContainer.find('.radioButtonGroupValue');
                    var fieldOptions = fieldSelectContainer.find('.fieldOptionsGroup');

                    if (fieldOptions.length)
                    {
                        fieldOptions.find('[value="APPROVAL"]').prop('disabled', !data.ApprovalRequiredEnabled);
                        if (!data.ApprovalRequiredEnabled)
                        {
                            fieldOptions.find('[value="APPROVAL"]').prop('checked', false);
                        }
                        if (data.SelectedValueCode)
                        {
                            skyward.controls.setValue(fieldOptions, data.SelectedValueCode);
                            radioButtonGroupValue.attr('value', data.SelectedValueCode);
                        }

                        updateSelectedField(fieldSelectContainer, listData, data.FieldID, data.GuidPath, isRelationship);
                    }
                }
            });

            fieldSelectModal.close();
        };

        const updateSelectedField = function (fieldSelectContainer, selectedFieldData, fieldID, guidPath, isRelationship)
        {
            if (fieldSelectContainer.length && selectedFieldData)
            {
                var selectedFieldValue = fieldSelectContainer.find('.elementFieldValue');
                var selectedGUIDFieldPathValue = fieldSelectContainer.find('.elementGUIDFieldPathValue');
                const fieldDisplayNameTextArea = fieldSelectContainer.find('.elementFieldDisplayName');
                var selectedFieldID = fieldSelectContainer.find('.elementFieldID');
                var selectedFieldPath = fieldSelectContainer.find('.elementFieldPath');
                const labelTextBox = fieldSelectContainer.find('.js-elementLabelTextBox');
                var selectedFieldIsRelationship = fieldSelectContainer.find('.elementFieldIsRelationship');

                var relationshipPathMinusRootObject = isRelationship
                    ? getRelationshipPathMinusInitialRootObject(selectedFieldData.fieldName)
                    : null;

                skyward.controls.setValue(selectedFieldValue, isRelationship ? relationshipPathMinusRootObject : selectedFieldData.absoluteFieldPath);
                skyward.controls.setValue(selectedGUIDFieldPathValue, guidPath);
                skyward.controls.setValue(fieldDisplayNameTextArea, selectedFieldData.fieldPath.replaceAll(".", " > "));
                skyward.controls.setValue(selectedFieldID, fieldID);
                skyward.controls.setValue(selectedFieldPath, selectedFieldData.fieldName);
                skyward.controls.setValue(selectedFieldIsRelationship, Boolean(isRelationship));
                selectedFieldID.attr('value', fieldID);

                const newLabel = selectedFieldData.displayPathText.split(" > ").pop();

                skyward.controls.setValue(labelTextBox, newLabel);
                labelTextBox.attr('value', newLabel);
            }
        };

        const buildSelectFieldPopup = function (dataModule, dataObject, isWorkflow, fieldSelectButton)
        {
            let fieldSelectContainer = fieldSelectButton.parents('.onlineformelement:eq(0)');
            let selectedFieldPathContainer = fieldSelectContainer.find('.elementFieldPath');
            let selectedFieldPath = skyward.controls.getValue(selectedFieldPathContainer);
            let selectedFieldContainer = fieldSelectContainer.find('.elementFieldValue');
            let selectedField = skyward.controls.getValue(selectedFieldContainer);

            if (!selectedField)
            {
                let selectedFieldIndex = selectedFieldPath.lastIndexOf('.');
                selectedField = selectedFieldPath.substring(selectedFieldIndex + 1);
            }

            return $.ajax(
            {
                url: skyward.global.virtualDir + "OnlineForm/Step/BuildTreeBrowse" + (isWorkflow ? 'Workflow' : 'Details'),
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    lookupModule: dataModule,
                    lookupObject: dataObject,
                    seekField: selectedField,
                    seekFieldPath: selectedFieldPath,
                }
            });
        };

        const deleteOnlineForm = function ()
        {
            const button = $(this);
            const onlineFormName = button.data('onlineformname');
            const onlineFormStartDate = button.data('onlineformstartdate');
            const onlineFormStatusID = button.data('onlineformstatusid');
            const portalName = button.data('portalname');
            const redirectArea = button.data('redirectarea');
            const redirectController = button.data('redirectcontroller');
            const redirectAction = button.data('redirectaction');
            const detailText = "This In-Progress Online Form will be deleted. You can start a new " +  onlineFormName + " form through the Dashboard.";
            const referenceItems =
            [
                { label: "Form Name", data: onlineFormName },
                { label: "This Form Started On", data: onlineFormStartDate }
            ];

            window.skyward.modalLayer.confirmDelete("In-Progress Online Form", detailText, { referenceItems }).then(function ()
            {
                return $.ajax(
                {
                    url: `${skyward.global.virtualDir}OnlineForm/OnlineFormStatus/${portalName}DeleteOnlineFormStatus/${onlineFormStatusID}`,
                    type: "POST"
                })
            }).then(function ()
            {   
                skyward.window.skipUnloadCheck = true;
                skyward.window.loadContent("full", redirectArea, redirectController, redirectAction);
            });
        };

        const printStepStatus = function ()
        {
            print($(this), $("#onlineForm_stepStatus"));
        };

        const print = function (button, container)
        {
            if (button.hasClass('ui-disabled'))
            {
                return;
            }
            const data = button.data();
            const url = skyward.global.virtualDir + "OnlineForm/" + data.url;
            skyward.htmlgatherer.getValues(container).catch((crossDomainException) => { }).then(values =>
            {
                const postData = { printValues: skyward.extensions.encodeHtml(JSON.stringify(values)) };
                $.extend(postData, data, { url: null });
                skyward.printScreen.launchWorkflow(url, postData);
            });
        };

        const printHtmlElement = function (button)
        {
            if (button.hasClass("ui-disabled"))
            {
                return;
            }
            const data = button.data();
            data.title = $('title').text();

            const url = skyward.global.virtualDir + 'OnlineForm/Element/' + data.screen + '/' + data.elementid;
            skyward.printScreen.launchWorkflow(url, data);
        };

        const externalLinkRedirect = function ()
        {
            const url = $(this).data().url;

            try
            {
                if (url.toUpperCase().indexOf("HTTP") == 0)
                {
                    window.open(url);
                }
                else
                {
                    window.open("//" + url);
                }
            }
            catch (error)
            {
                skyward.modalLayer.showCriticalDialog("Error", `<span class='boldFont'>Could not navigate to ${url}.</span>\n\n` + "Please try again later. If the error persists contact your school district.");
                console.error(error);
            }
        };

        const setupIFrame = async function (iFrame)
        {
            if (iFrame.data('finished-setup'))
            {
                return;
            }
            iFrame.data('finished-setup', true);

            await waitForIFrameReady(iFrame).catch((crossDomainException) => { });
            await performSetup();

            async function performSetup()
            {
                removeBackgroundImage();
                await setupElements();

                if (iFrame.hasClass('htmlContentElement') || iFrame.hasClass('onlineFormsHtmlViewer'))
                {
                    await setupChangeTracking(iFrame);
                    await skyward.onlineform.setupIframeHeight(iFrame, "setup");
                }
            }

            function removeBackgroundImage()
            {
                iFrame.removeClass('loading');
            }

            function setupElements()
            {
                if (!iFrame.hasClass("htmlContentElement"))
                {
                    return Promise.resolve();
                }

                return skyward.iframeListener.setupElements(iFrame).catch((crossDomainException) => { });
            }

            function setupChangeTracking(iFrame)
            {
                return skyward.iframeListener.setupChangeTracking(iFrame, (dirty) =>
                {
                    iFrame.attr('data-dirty', dirty);
                });
            }

            function waitForIFrameReady(iFrame)
            {
                return skyward.iframeListener.ready(iFrame);
            }
        };

        skyward.onlineform.setupIframeHeight = async function (iFrame, reason)
        {
            // try-catch handles any failed attempts of setting the IFrame height. Ex: cross domain issues.
            try
            {
                var scrollParent = iFrame.scrollParent();
                var originalParentOverflowY = scrollParent.is(document)
                    ? undefined
                    : scrollParent.css("overflow-y");

                // can't adjust css of document
                if (!scrollParent.is(document))
                {
                    scrollParent.css('overflow-y', 'scroll');
                }

                await skyward.iframeListener.setDocumentOverflow(iFrame, "hidden");

                //reset the height on the iFrame
                iFrame.height("auto");

                const height = await skyward.iframeListener.getHeight(iFrame);
                iFrame.height(height + skyward.window.scrollbarHeight);

                if (!scrollParent.is(document))
                {
                    scrollParent.css('overflow-y', originalParentOverflowY);
                }

                // force text to reflow without the scrollbar before restoring it - otherwise it may use the old layout, which could wrap earlier and
                // require a scrollbar
                await new Promise(resolve =>
                {
                    requestAnimationFrame(async function ()
                    {
                        await skyward.iframeListener.setDocumentOverflow(iFrame, "");
                        resolve();
                    });
                });

                // iFrame.height("auto") can cause eels to not display correctly when selected if the step it's on is large, this sets the scroll bar back to where it was when the eel opened.
                var scrollBarArea = $('.onlineForm.pseudoContentArea');
                if (scrollBarArea.length)
                {
                    var scrollTopOriginalValue = scrollBarArea[0].scrollTop;
                    scrollBarArea.scrollTop(scrollTopOriginalValue);
                }
            }
            catch (e)
            {
                console.log("Unable to set up IFrame height", e);
            }
        };

        var setupHtmlIFrame = async function (htmlContainer, iFrame)
        {
            var data;

            var htmlSelector = htmlContainer.find('.radioButtonGroup.onlineForm.htmlSelector');
            if (htmlSelector.length)
            {
                var selectedInput = htmlSelector.find('input:checked');

                data = htmlSelector.data();
                data.key = selectedInput.val();

                htmlSelector.find('.htmlSelectorOption input').change(async function ()
                {
                    var input = $(this);

                    data.elementstatusid = null;
                    data.key = input.val();
                    data.hash = input.data().hash;

                    await changeIFrameHtmlSrc(iFrame, data);
                    await skyward.onlineform.setupIframeHeight(iFrame, "changesrc");
                });
            }
            else
            {
                data = iFrame.data();
            }

            await changeIFrameHtmlSrc(iFrame, data);
            await skyward.onlineform.setupIframeHeight(iFrame, "changesrc");
        };

        var setupMergeMarkup = function (mergeMarkupContainer)
        {
            var selectorRadioButtonGroup = mergeMarkupContainer.find('.mergeMarkupSelector');
            if (!selectorRadioButtonGroup.length)
            {
                return;
            }

            var oldValue = skyward.controls.getValue(selectorRadioButtonGroup);

            selectorRadioButtonGroup.on("change", "input", function ()
            {
                var newValue = skyward.controls.getValue(selectorRadioButtonGroup);

                var oldFrame = mergeMarkupContainer.find("iframe[data-version='" + oldValue + "']");
                var newFrame = mergeMarkupContainer.find("iframe[data-version='" + newValue + "']");

                oldFrame.addClass("js-ignoreIFrameContents").hide();
                newFrame.removeClass("js-ignoreIFrameContents").show();
                setupIFrame(newFrame);

                oldValue = newValue;
            });
        };

        var setupEmbeddedLink = function (iFrame)
        {
            iFrame.closest('.onlineForm.stepStatusContent.details').addClass('outerIFrameContainer');
        };

        var changeIFrameHtmlSrc = function (iFrame, data)
        {
            const { id, hash, action } = data.elementstatusid
                ? { id: data.elementstatusid, hash: data.elementstatushash, action: data.elementstatusaction }
                : { id: data.elementid, hash: data.elementhash, action: data.elementaction }

            var newSrc = `${skyward.global.virtualDir}OnlineForm/Element/${action}/${id}?key=${data.key}&hash=${hash}`;

            const promise = new Promise((resolve, reject) =>
            {
                iFrame.one("load", resolve);
                iFrame.one("error", reject);

                iFrame.attr("src", newSrc);
            });
            iFrame.data("loadPromise", promise);
            return promise;
        };

        var languageOptionTypeRadioGroupChange = function (e)
        {
            var value = $(this).find(':checked').val();
            var portal = $(this).data('portal');

            // Only fire ajax when the target of the event was the checked radio button (e.g. ignore hidden input change)
            if (e.target.checked)
            {
                if (portal)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + '/OnlineForm/StepStatus/UpdateLanguageOption' + portal,
                        type: "POST",
                        data: { LanguageOptionTypeCode: value }
                    });
                }
            }
        };

        skyward.onlineform.raceEthnicityGetValue = function (raceEthnicity)
        {
            raceEthnicity = raceEthnicity instanceof $ ? raceEthnicity : $(raceEthnicity);
            return raceEthnicity.find('.raceEthnicityVerificationHiddenValue').val();
        };

        skyward.onlineform.nseChangeBirthDate = function (onlineFormStatusID, onlineFormID, entityID, nameID)
        {
            const warningDescription = "Changing the birth date will recalculate the student's grade, causing the form to reset.";

            showNSERestartOnlineFormStatusWarning(onlineFormStatusID, onlineFormID, entityID, nameID, "change the birth date", warningDescription);
        };

        skyward.onlineform.nseChangeGrade = function (onlineFormStatusID, onlineFormID, entityID, nameID)
        {
            const warningDescription = "Changing the Grade will cause the form to reset.";

            showNSERestartOnlineFormStatusWarning(onlineFormStatusID, onlineFormID, entityID, nameID, "change the Grade", warningDescription);
        };

        const showNSERestartOnlineFormStatusWarning = function (onlineFormStatusID, onlineFormID, entityID, nameID, warningAction, warningDescription)
        {
            const redirectToNSERestartOnlineFormStatus = function ()
            {
                const dataParams = {
                    EntityID: entityID,
                    NameID: nameID,
                    OnlineFormID: onlineFormID
                };

                skyward.window.loadContent("full", "OnlineForm", "OnlineFormStatus", "NSERestartOnlineFormStatus", onlineFormStatusID, dataParams);
            };

            const fullWarningDescription = `${warningDescription}\n\nYour progress will be lost, and then the form will restart.`;

            skyward.modalLayer.showWarningDialog(warningAction, fullWarningDescription, { onConfirm: redirectToNSERestartOnlineFormStatus });
        };

        skyward.onlineform.redirectToPreviewCreate = function (event, buttonData, previewCreateActionPrefix)
        {
            const currentEvent = $(event.currentTarget);
            const onlineFormID = currentEvent.data("online-form-id");
            const stepID = currentEvent.data("step-id");

            let workflowContent = $(".workflowContent");
            var promise = $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/commit",
                {
                    type: "POST",
                    dataType: "json",
                    data: skyward.workflow.getScreenValues(workflowContent.eq(0), null),
                    activityIndicator: { isWorkflowAjaxRequest: true }
                });

            promise.then(function (data)
            {
                if (data.workflowStatus === "F")
                {
                    // Invalid
                    var baseWarningError = $(".workflow").find("#baseWorkflowErrorContainer");
                    skyward.validation.displayValidationMessages(data, workflowContent, baseWarningError);
                }
                else
                {
                    buttonData["IsFromStartPreviewWorkflow"] = true;
                    buttonData["StepID"] = stepID;

                    skyward.window.loadContent("popout", "OnlineForm", "OnlineForm", `${previewCreateActionPrefix}PreviewCreate`, onlineFormID, buttonData, null, null, null, "false", null, null, null, null, null, null);
                    skyward.workflow.closeWorkflowPopup();
                }
            });
        };

        skyward.onlineform.redirectToNewStudentEnrollmentPreviewCreate = function (event)
        {
            let buttonData = {
                "BirthDate": $('.js-nsePopupBirthDateAgeTextBox')?.val(),
                "GradeReferenceID": skyward.controls.getValue($('.js-nsePopupGradeReferenceComboBox')),
                "NameID": $(event.currentTarget).data("online-form-name-id"),
                "OnlineFormEntityID": skyward.controls.getValue($('.js-nsePopupOnlineFormEntityCodeEEL'))
            };

            skyward.onlineform.redirectToPreviewCreate(event, buttonData, "NewStudentEnrollment");
        };

        var redirectToNonNewStudentEnrollmentPreviewCreate = function (event, buttonData, previewCreateActionPrefix)
        {
            buttonData["OnlineFormEntityID"] = $(event.currentTarget).data("online-form-entity-id");

            skyward.onlineform.redirectToPreviewCreate(event, buttonData, previewCreateActionPrefix);
        };

        skyward.onlineform.redirectToEmployeePreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "EmployeeID": skyward.controls.getValue($("#EmployeeID_value")) }, "Employee");
        };

        skyward.onlineform.redirectToFamilyPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "StudentID": skyward.controls.getValue($("#StudentID_value")), "StudentFamilyID": skyward.controls.getValue($("#StudentFamilyID_value")) }, "Family");
        };

        skyward.onlineform.redirectToStudentPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "StudentID": skyward.controls.getValue($("#StudentID_value")) }, "Student");
        };

        skyward.onlineform.redirectToTeacherPreviewCreate = function (event)
        {
            let buttonData =
            {
                "DisplayPeriodID": skyward.controls.getValue($('#OnlineFormStatusDisplayPeriodID_value')),
                "SectionID": skyward.controls.getValue($('#OnlineFormStatusSectionID_value')),
                "StaffID": skyward.controls.getValue($("#StaffID_value"))
            };

            redirectToNonNewStudentEnrollmentPreviewCreate(event, buttonData, "Teacher");
        };

        skyward.onlineform.redirectToUserPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "UserID": skyward.controls.getValue($("#UserID_value")) }, "User");
        };

        const allowLanguageUpdateCheckboxChange = function ()
        {
            const allowLanguageUpdateCheckbox = $(this);

            if (skyward.controls.getValue(allowLanguageUpdateCheckbox))
            {
                const onlineFormElement = closestOnlineFormElement(allowLanguageUpdateCheckbox);

                if (onlineFormElementIsApprovalNeeded(onlineFormElement))
                {
                    setCodeListRequiredCheckboxValue(onlineFormElement, true);
                }
            }
        };

        const approvalOptionRadioButtonGroupChange = function ()
        {
            const radioButtonGroup = $(this);
            const onlineFormElement = closestOnlineFormElement(radioButtonGroup);

            if (skyward.controls.getValue(onlineFormElement.find(".js-elementTypeComboBox")) === "K")
            {
                const isApprovalNeeded = skyward.controls.getValue(radioButtonGroup) === "APPROVAL";

                skyward.controls.toggleVisible(onlineFormElement.find(".js-codeListRequiredFieldSet"), isApprovalNeeded);

                const requiredElementCheckbox = findCodeListRequiredCheckbox(onlineFormElement);

                if (isApprovalNeeded)
                {
                    let enableRequiredElementCheckbox = true;

                    if (onlineFormElementCodeListIsLanguage(onlineFormElement) && onlineFormElementAllowLanguageUpdate(onlineFormElement))
                    {
                        skyward.controls.setValue(requiredElementCheckbox, true);

                        enableRequiredElementCheckbox = false;
                    }

                    skyward.controls.toggle(requiredElementCheckbox, enableRequiredElementCheckbox);
                }
                else
                {
                    skyward.controls.setValue(requiredElementCheckbox, false);
                }
            }
        };

        const approvalNeededRadioButtonChange = function (event)
        {
            if ($(event.target).prop("checked"))
            {
                const approvalNeededRadioButton = $(this);
                const onlineFormElement = closestOnlineFormElement(approvalNeededRadioButton);

                if (fieldGroupTypeRequiresApprovalOnChange(onlineFormElement.find(".js-fieldGroupTypeComboBox")))
                {
                    showRequireApprovalOnChange(onlineFormElement);
                }
            }
        };

        const elementTypeComboBoxChange = function (_event)
        {
            const elementTypeComboBox = $(this);

            if (skyward.controls.getValue(elementTypeComboBox) === "K")
            {
                const onlineFormElement = closestOnlineFormElement(elementTypeComboBox);
                let isRequired = onlineFormElementCodeListIsLanguage(onlineFormElement) && onlineFormElementIsApprovalNeeded(onlineFormElement) && onlineFormElementAllowLanguageUpdate(onlineFormElement);

                setCodeListRequiredCheckboxValue(onlineFormElement, isRequired);
            }
        }

        const fieldGroupTypeComboBoxChange = function (_event)
        {
            const fieldGroupTypeComboBox = $(this);

            if (fieldGroupTypeRequiresApprovalOnChange(fieldGroupTypeComboBox) && elementIsApprovalNeeded(fieldGroupTypeComboBox))
            {
                showRequireApprovalOnChange(closestOnlineFormElement(fieldGroupTypeComboBox));
            }
        };

        const fieldGroupTypeRequiresApprovalOnChange = function (fieldGroupComboBox)
        {
            return fieldGroupComboBox.find("option:selected").hasClass("js-requireApprovalOnChangeFieldGroupType");
        };

        const elementIsApprovalNeeded = function (viewPart)
        {
            return skyward.controls.getValue(closestOnlineFormElement(viewPart).find(".js-approvalOptionRadioButtonGroup")) === "APPROVAL";
        };

        const showRequireApprovalOnChange = function (onlineFormElement)
        {
            skyward.controls.toggleVisible(onlineFormElement.find(".js-fsRequireApprovalOnChange"), true);
        }

        const onlineFormElementAllowLanguageUpdate = function (onlineFormElement)
        {
            const allowLanguageUpdateCheckbox = onlineFormElement.find(".js-allowLanguageUpdateCheckbox");

            return !allowLanguageUpdateCheckbox.length || skyward.controls.getValue(allowLanguageUpdateCheckbox);
        };

        const onlineFormElementCodeListIsLanguage = function (onlineFormElement)
        {
            return skyward.controls.getValue(onlineFormElement.find(".js-codeListTypeComboBox")) === "Student.Student.NativeLanguage";
        };

        const onlineFormElementIsApprovalNeeded = function (onlineFormElement)
        {
            return skyward.controls.getValue(onlineFormElement.find(".js-approvalOptionRadioButtonGroup")) === "APPROVAL";
        };

        const findCodeListRequiredCheckbox = function (onlineFormElement)
        {
            return onlineFormElement.find(".js-codeListRequiredCheckbox");
        };

        const setCodeListRequiredCheckboxValue = function (onlineFormElement, value)
        {
            skyward.controls.setValue(findCodeListRequiredCheckbox(onlineFormElement), value);
        };

        const closestOnlineFormElement = function (viewPart)
        {
            return viewPart.closest('.onlineformelement');
        };

        var sendContactMessage = function (modal, buttonData)
        {
            buttonData.contactEmail = modal.content.findPrefixed('#ContactDistrictEmailText').val();
            buttonData.contactMessage = modal.content.findPrefixed('#ContactDistrictMessageText').val();
            return $.ajax({
                url: skyward.global.virtualDir + buttonData.action,
                data: buttonData,
                success: function (data)
                {
                    if (data.success)
                    {
                        modal.close();
                        skyward.modalLayer.showDialog("Message Sent", "Thank you, your message has been sent.", [{ text: 'Done', icon: 'Check', click: 'close' }]);

                    }
                    else
                    {
                        var baseErrorContainer = modal.content.find('#CurrentRecordContentBaseError');
                        skyward.validation.displayValidationMessages(data, modal.container, baseErrorContainer);
                    }
                }
            });
        };

        var showContact = function ()
        {
            var buttonData = $(this).data();

            var sendButton = { text: "Send", click: function () { sendContactMessage(modal, buttonData); }, icon: "Email" };
            var closeButton = { text: "Close", click: function () { modal.close(); }, icon: "Close" };
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + buttonData.popupaction,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            var modal = skyward.modalLayer.showDialog("Contact District", buildPopup, [sendButton, closeButton]);
        };

        var showTeacherOnlineForms = function ()
        {
            if ($(event.target).hasClass("tileBrowseIgnoreTileClick"))
            {
                return;
            }
            var tileContainer = $(this);

            var data = tileContainer.data();
            var selectedTileClass = "selectedOnlineFormTile";
            var browseName = tileContainer.closest(".browse").attr("id");
            
            tileContainer.siblings().removeClass(selectedTileClass);
            tileContainer.addClass(selectedTileClass);
            skyward.browse.setCurrentBrowseName(browseName);
            var detailsPanelOptions =
            {
                panelWidth: data.panelwidth,
                useCloseButton: true,
                additionalData:
                {
                    opener: tileContainer
                }
            };
            skyward.detailsPanel.openDetailsPanel(data.module, data.object, data.screen, data.primarykey, data, detailsPanelOptions);
        };

        const buildOnlineFormStatusLegendPopup = function ()
        {
            const buildPopup = function ()
            {
                return $.ajax({
                    url: `${skyward.global.virtualDir}OnlineForm/OnlineFormStatus/BuildLegendPopup`,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            const options =
            {
                anchorTo: $(this)
            };

            skyward.modalLayer.showDialog("Legend", buildPopup, { text: "Close", icon: "Close" }, options);
        };

        const setStepFilterModifiedNotification = function (selectorElement, panelClass, filterValueClass)
        {
            const panel = selectorElement.find(panelClass);

            if (panel.length)
            {
                panel.on("change dirty", filterValueClass, null, skyward.promptsview.setModifiedNotification);
                panel.each(skyward.promptsview.setModifiedNotification);
            }
        };

        function getNameOrId(element)
        {
            return element.attr("name") || element.getIdAndPrefix().id || "";
        }

        const events =
        {
            'redirectToExternalLink': externalLinkRedirect,
            'contactUs': showContact,
            'showteacheronlineforms': showTeacherOnlineForms,
            printStepStatus,
            buildOnlineFormStatusLegendPopup,
        };

        skyward.events.registerEvents('onlineform', events);

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);